import {ApolloClient} from 'apollo-client'
import {createHttpLink} from 'apollo-link-http'
import {onError} from 'apollo-link-error'
import {InMemoryCache} from 'apollo-cache-inmemory'
import store from '../stores/reduxStore'
import {openNotAuthorized} from '../actions/notAuthorized'
import {API_BASE_URL} from './apiConfig'
import { RetryLink } from 'apollo-link-retry'
import {cable} from './api/webSocket'
import ActionCableLink from 'graphql-ruby-client/subscriptions/ActionCableLink'
import { ApolloLink } from 'apollo-link'
import { AuthLink } from './api/AuthLink'
import Sentry from './sentry'

const hasSubscriptionOperation = ({ query: { definitions } }) => {
  return definitions.some(
    ({ kind, operation }) => kind === 'OperationDefinition' && operation === 'subscription',
  )
}

const httpLink = createHttpLink({
  uri: `${API_BASE_URL}/graphql`,
})

const retryLink = new RetryLink()

const errorLink = onError(({graphQLErrors, networkError, operation}) => {
  if (graphQLErrors) {
    let notAuthorized = false
    graphQLErrors.forEach(({message, locations, path}) => {
      if (/Not authorized/.exec(message)) {
        notAuthorized = true
      } else {
        console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
        Sentry.captureException(new Error(`GraphQL error: ${message}`), {
          contexts: {
            graphql: {
              operation: operation.operationName,
              variables: operation.variables,
              path: path
            }
          }
        })
      }
    })

    if (notAuthorized) {
      store.dispatch(openNotAuthorized())
    }
  }

  if (networkError) {
    console.error(`[networkError]: ${networkError}`, {
      status_code: networkError.statusCode, 
      body: networkError.bodyText ? networkError.bodyText.substring(0, 255) : 'No body'
    })
    Sentry.captureException(networkError, {
      contexts: {
        network: {
          operation: operation.operationName,
          statusCode: networkError.statusCode
        }
      }
    })
  }
})

const authLink = new AuthLink()

const link = ApolloLink.split(
  hasSubscriptionOperation,
  new ActionCableLink({cable}),
  retryLink.concat(authLink.concat(errorLink.concat(httpLink)))
)

const apollo_client = new ApolloClient({
  link: link,
  cache: new InMemoryCache()
})

authLink.injectClient(apollo_client)

export default apollo_client



// WEBPACK FOOTER //
// ./src/utils/apollo.js